import { parseAlgoliaHitHighlight } from '@algolia/autocomplete-preset-algolia'

import { PluginHit } from '../../plugins'
import styles from './HighlightedText.module.css'
import { HighlightedPart, HighlightedTextProps } from './HighlightedText.types'

const getHighlightedText = (
	result: PluginHit,
	field: string | string[]
): HighlightedPart[] => {
	const fallbackLocale = Array.isArray(field)
		? field.find((f) => f.includes('en'))
		: field

	// Determine which field(s) to use
	const fieldsToTry = Array.isArray(field) ? field : [field]

	// Try each field until we get results
	for (const fieldName of fieldsToTry) {
		try {
			const parts = parseAlgoliaHitHighlight({
				hit: result,
				attribute: fieldName as keyof PluginHit,
			})

			if (parts.length > 0) {
				return parts
			}
		} catch {
			// Continue to next field
		}
	}

	// Fallback to plain text from first available field
	const text = result[fallbackLocale] as string
	return text ? [{ value: text, isHighlighted: false }] : []
}

export const HighlightedText: React.FC<HighlightedTextProps> = ({
	AlgoliaHit,
	fields,
}) => {
	if (!AlgoliaHit || fields.length === 0) return null

	const textToHighlight = getHighlightedText(AlgoliaHit, fields)

	return (
		<>
			{textToHighlight.map((part, index) =>
				part.isHighlighted ? (
					<span key={index} className={styles.highlighted}>
						{part.value}
					</span>
				) : (
					part.value
				)
			)}
		</>
	)
}

export default HighlightedText
